var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVodafoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.002 48.0015C37.2573 48.0015 48.0028 37.256 48.0028 24.0008C48.0028 10.7455 37.2573 0 24.002 0C10.7467 0 0.0012207 10.7455 0.0012207 24.0008C0.0012207 37.256 10.7467 48.0015 24.002 48.0015Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1899 37.3011C17.6367 37.3227 10.8172 31.7301 10.7879 22.7477C10.7694 16.8071 13.9729 11.0836 18.0693 7.69696C22.0717 4.38879 27.5381 2.26596 32.5027 2.24902C33.1415 2.24902 33.8096 2.29982 34.2191 2.43837C29.878 3.33892 26.4236 7.3783 26.439 11.9611C26.4386 12.091 26.4484 12.2207 26.4682 12.349C33.7311 14.1178 37.0285 18.5066 37.0485 24.5642C37.0686 30.6217 32.281 37.2734 24.1899 37.3011Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.0012207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodafoneLogo);
export default __webpack_public_path__ + "static/media/vodafone-logo.1eaa94cf63004b199eaa317820f5ae0a.svg";
export { ForwardRef as ReactComponent };